import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react'

import debounce from 'lodash/debounce'

export function useDebounced<T extends Parameters<typeof debounce>[0]>(fn: T) {
  return useRef(debounce(fn, 500)).current
}

export function useSyncedState<T>(value: T): [T, Dispatch<SetStateAction<T>>] {
  const [state, setState] = useState(value)

  useEffect(() => {
    setState(value)
  }, [value])

  return [state, setState]
}
